import { CONSTANTS } from "src/constants";
import {
  AdjustAmountPayload,
  CreditMemoDeductPayload,
  CreditMemoPayload,
  EditInvoiceAfterSendPayload,
  InvoiceListPayload,
  ManualInvoicePayload,
  MarkAsPaidBody,
  MarkPaymentPayload,
  OnAccountPayload,
} from "src/models/invoice.models";
import { replacePlaceholders, urlReplace } from "src/utils/common.utils";

import API_URL from "./apiConfig/api.config";
import handleResponse from "./apiConfig/api.response.service";
import apiCall from "./apiConfig/apiCall.config";

export async function getInvoiceList(params?: InvoiceListPayload) {
  const res = await apiCall.get(API_URL.INVOICE.GET_INVOICE_LIST, {
    ...params,
  });
  const responseData = await handleResponse(res);

  return responseData;
}

export async function getInvoiceDetails(
  invoiceUuid: string,
  listParams?: InvoiceListPayload
) {
  const res = await apiCall.get(
    `${API_URL.INVOICE.GET_INVOICE_DETAILS}${invoiceUuid}/office`,
    { ...listParams }
  );
  const responseData = await handleResponse(res);

  return responseData;
}

export async function getInvoiceJobDetails(
  invoiceUuid: string,
  officeUuid: string
) {
  const res = await apiCall.get(
    `${API_URL.INVOICE.GET_INVOICE_DETAILS}${invoiceUuid}/job/${officeUuid}`
  );
  const responseData = await handleResponse(res);

  return responseData;
}

export async function getInvoiceTimeSheetDetails(jobDateUuid: string) {
  const res = await apiCall.get(
    `${API_URL.INVOICE.GET_INVOICE_DETAILS}${jobDateUuid}/timesheet`
  );
  const responseData = await handleResponse(res);

  return responseData;
}
export async function getMasterInvoiceList(params?: InvoiceListPayload) {
  const res = await apiCall.get(API_URL.INVOICE.GET_MASTER_INVOICE_LIST, {
    ...params,
  });
  const responseData = await handleResponse(res);

  return responseData;
}
export async function getOnAccountList(params: InvoiceListPayload) {
  const res = await apiCall.get(API_URL.INVOICE.GET_ON_ACCOUNT_LIST, {
    ...params,
  });
  const responseData = await handleResponse(res);

  return responseData;
}

export async function createOnAccount(body: OnAccountPayload) {
  const res = await apiCall.post(API_URL.INVOICE.GET_ON_ACCOUNT_LIST, body);
  const responseData = await handleResponse(
    res,
    CONSTANTS.NOT_VALUE,
    CONSTANTS.COMMON_CONSTANTS.SHOW,
    CONSTANTS.COMMON_CONSTANTS.SHOW
  );

  return responseData;
}

export async function updateOnAccount(uuid: string, body: OnAccountPayload) {
  const res = await apiCall.patch(
    `${API_URL.INVOICE.GET_ON_ACCOUNT_LIST}/${uuid}`,
    body
  );
  const responseData = await handleResponse(
    res,
    CONSTANTS.NOT_VALUE,
    CONSTANTS.COMMON_CONSTANTS.SHOW,
    CONSTANTS.COMMON_CONSTANTS.SHOW
  );

  return responseData;
}

export async function getCreditMemoList(params: InvoiceListPayload) {
  const res = await apiCall.get(API_URL.INVOICE.GET_CREDIT_MEMO_LIST, {
    ...params,
  });
  const responseData = await handleResponse(res);

  return responseData;
}

export async function createCreditMemo(body: CreditMemoPayload) {
  const res = await apiCall.post(API_URL.INVOICE.CREATE_CREDIT_MEMO, body);
  const responseData = await handleResponse(
    res,
    CONSTANTS.NOT_VALUE,
    CONSTANTS.COMMON_CONSTANTS.SHOW,
    CONSTANTS.COMMON_CONSTANTS.SHOW
  );

  return responseData;
}

export async function deductCreditMemo(body: CreditMemoDeductPayload) {
  const res = await apiCall.patch(
    API_URL.INVOICE.DEDUCT_CREDIT_MEMO + body.officeId,
    {
      amount: body.amount,
      comment: body.comment,
      transaction_id: body.transactionId,
    }
  );
  const responseData = await handleResponse(
    res,
    CONSTANTS.NOT_VALUE,
    CONSTANTS.COMMON_CONSTANTS.SHOW,
    CONSTANTS.COMMON_CONSTANTS.SHOW
  );

  return responseData;
}

export async function getTimesheetPayments(params: InvoiceListPayload) {
  const res = await apiCall.get(API_URL.INVOICE.GET_TIME_SHEET_PAYMENTS, {
    ...params,
  });
  const responseData = await handleResponse(res);

  return responseData;
}

export async function markAsPaid(uuid: string, body: MarkAsPaidBody) {
  const url = urlReplace(
    API_URL.INVOICE.MARK_TIMESHEET_PAYMENT,
    "professionalUuid",
    uuid
  );
  const res = await apiCall.patch(url, body);
  const responseData = await handleResponse(
    res,
    CONSTANTS.NOT_VALUE,
    CONSTANTS.COMMON_CONSTANTS.SHOW,
    CONSTANTS.COMMON_CONSTANTS.SHOW
  );

  return responseData;
}
export async function markAsPaidLatePayment(body: MarkAsPaidBody) {
  const url = API_URL.INVOICE.MARK_TIMESHEET_LATE_PAYMENT;
  const res = await apiCall.post(url, body);
  const responseData = await handleResponse(
    res,
    CONSTANTS.NOT_VALUE,
    CONSTANTS.COMMON_CONSTANTS.SHOW,
    CONSTANTS.COMMON_CONSTANTS.SHOW
  );

  return responseData;
}
export async function createManualInvoice(body: ManualInvoicePayload) {
  const res = await apiCall.post(API_URL.INVOICE.CREATE_MANUAL_INVOICE, body);
  const responseData = await handleResponse(
    res,
    CONSTANTS.NOT_VALUE,
    CONSTANTS.COMMON_CONSTANTS.SHOW,
    CONSTANTS.COMMON_CONSTANTS.SHOW
  );

  return responseData;
}

export async function updateManualInvoice(
  invoiceUuid: string,
  body: ManualInvoicePayload
) {
  const res = await apiCall.patch(
    `${API_URL.INVOICE.GET_INVOICE_DETAILS}${invoiceUuid}`,
    body
  );
  const responseData = await handleResponse(
    res,
    CONSTANTS.NOT_VALUE,
    CONSTANTS.COMMON_CONSTANTS.SHOW,
    CONSTANTS.COMMON_CONSTANTS.SHOW
  );

  return responseData;
}

export async function cancelManualInvoice(invoiceUuid: string, reason: string) {
  const res = await apiCall.patch(
    `${API_URL.INVOICE.GET_INVOICE_DETAILS}${invoiceUuid}/cancel`,
    { cancel: true, reason }
  );
  const responseData = await handleResponse(
    res,
    CONSTANTS.NOT_VALUE,
    CONSTANTS.COMMON_CONSTANTS.SHOW,
    CONSTANTS.COMMON_CONSTANTS.SHOW
  );

  return responseData;
}

export async function getOnAccountLogs(officeUuid: string) {
  const res = await apiCall.get(
    `${API_URL.INVOICE.GET_ON_ACCOUNT_LIST}/${officeUuid}/logs`
  );
  const responseData = await handleResponse(res);

  return responseData;
}

export async function getCreditMemoLogs(officeUuid: string) {
  const res = await apiCall.get(
    `${API_URL.INVOICE.GET_INVOICE_DETAILS}${officeUuid}/credit-memo/logs`
  );
  const responseData = await handleResponse(res);

  return responseData;
}

export async function getPaymentList(invoiceUuid: string) {
  const res = await apiCall.get(
    `${API_URL.INVOICE.GET_INVOICE_DETAILS}${invoiceUuid}/payments`
  );
  const responseData = await handleResponse(res);

  return responseData;
}

export async function updateAmount(
  invoiceUuid: string,
  body: AdjustAmountPayload
) {
  const res = await apiCall.patch(
    `${API_URL.INVOICE.GET_INVOICE_DETAILS}${invoiceUuid}`,
    body
  );
  const responseData = await handleResponse(
    res,
    CONSTANTS.NOT_VALUE,
    CONSTANTS.COMMON_CONSTANTS.SHOW,
    CONSTANTS.COMMON_CONSTANTS.SHOW
  );

  return responseData;
}

export async function markPayment(
  invoiceUuid: string,
  body: MarkPaymentPayload
) {
  const res = await apiCall.patch(
    `${API_URL.INVOICE.GET_INVOICE_DETAILS}${invoiceUuid}/payment`,
    body
  );
  const responseData = await handleResponse(
    res,
    CONSTANTS.NOT_VALUE,
    CONSTANTS.COMMON_CONSTANTS.SHOW,
    CONSTANTS.COMMON_CONSTANTS.SHOW
  );

  return responseData;
}

export async function getOfficeListWithAmount(invoiceUuid: string) {
  const res = await apiCall.get(
    `${API_URL.INVOICE.GET_INVOICE_DETAILS}${invoiceUuid}/office-amount`
  );
  const responseData = await handleResponse(res);

  return responseData;
}

export async function sentInvoice(invoiceUuids: string[]) {
  const res = await apiCall.post(`${API_URL.INVOICE.GET_INVOICE_DETAILS}send`, {
    invoice: invoiceUuids,
  });
  const responseData = await handleResponse(
    res,
    CONSTANTS.NOT_VALUE,
    CONSTANTS.COMMON_CONSTANTS.SHOW,
    CONSTANTS.COMMON_CONSTANTS.SHOW
  );

  return responseData;
}

export async function resendInvoice(invoiceUuids: string[]) {
  const res = await apiCall.post(
    `${API_URL.INVOICE.GET_INVOICE_DETAILS}resend`,
    {
      invoice: invoiceUuids,
    }
  );
  const responseData = await handleResponse(
    res,
    CONSTANTS.NOT_VALUE,
    CONSTANTS.COMMON_CONSTANTS.SHOW,
    CONSTANTS.COMMON_CONSTANTS.SHOW
  );

  return responseData;
}

export async function getCreditMemoInfo(officeUuid: string) {
  const res = await apiCall.get(
    `${API_URL.INVOICE.GET_INVOICE_DETAILS}${officeUuid}/credit-memo`
  );
  const responseData = await handleResponse(res);

  return responseData;
}

export async function getStatement({
  type,
  office,
  start_date,
  end_date,
}: {
  end_date: string;
  office: string;
  start_date: string;
  type: number;
}) {
  const res = await apiCall.getBlobFile(API_URL.INVOICE.GET_INVOICE_STATEMENT, {
    type,
    start_date,
    end_date,
    office,
  });
  const responseData = await handleResponse(res);

  return responseData;
}

export async function addAddendum(body: FormData) {
  const res = await apiCall.fileUploadApi(API_URL.INVOICE.ADD_ADDENDUM, body);
  const responseData = await handleResponse(
    res,
    CONSTANTS.NOT_VALUE,
    CONSTANTS.COMMON_CONSTANTS.SHOW,
    CONSTANTS.COMMON_CONSTANTS.SHOW
  );

  return responseData;
}

export async function signAddendum(body: FormData) {
  const res = await apiCall.fileUploadApi(API_URL.INVOICE.SIGN_ADDENDUM, body);
  const responseData = await handleResponse(
    res,
    CONSTANTS.NOT_VALUE,
    CONSTANTS.COMMON_CONSTANTS.SHOW,
    CONSTANTS.COMMON_CONSTANTS.SHOW
  );

  return responseData;
}

export async function getProfessionalTimesheetJob(
  professionalUuid: string,
  payload: { end_date: string; start_date: string }
) {
  const url = urlReplace(
    API_URL.INVOICE.GET_PROFESSIONAL_TIMESHEET_JOB,
    "professionalUuid",
    professionalUuid
  );
  const res = await apiCall.get(url, payload);
  const responseData = await handleResponse(res);

  return responseData;
}

export async function getJobTimesheets(jobUuid: string, invoiceUuid: string) {
  const url = replacePlaceholders(API_URL.INVOICE.GET_JOB_TIMESHEETS, {
    jobUuid,
    invoiceUuid,
  });
  const res = await apiCall.get(url);
  const responseData = await handleResponse(res);

  return responseData;
}

export async function getInvoiceHistory(invoiceUuid: string) {
  const url = replacePlaceholders(API_URL.INVOICE.GET_INVOICE_HISTORY, {
    invoiceUuid,
  });
  const res = await apiCall.get(url);
  const responseData = await handleResponse(res);

  return responseData;
}

export async function voidInvoice(invoiceUuid: string) {
  const res = await apiCall.patch(
    `${API_URL.INVOICE.GET_INVOICE_DETAILS}${invoiceUuid}/void`
  );
  const responseData = await handleResponse(
    res,
    CONSTANTS.NOT_VALUE,
    CONSTANTS.COMMON_CONSTANTS.SHOW,
    CONSTANTS.COMMON_CONSTANTS.SHOW
  );

  return responseData;
}

export async function editInvoiceAfterSend(
  invoiceUuid: string,
  body: EditInvoiceAfterSendPayload
) {
  const res = await apiCall.patch(
    `${API_URL.INVOICE.GET_INVOICE_DETAILS}${invoiceUuid}/change-after-send`,
    body
  );
  const responseData = await handleResponse(
    res,
    CONSTANTS.NOT_VALUE,
    CONSTANTS.COMMON_CONSTANTS.SHOW,
    CONSTANTS.COMMON_CONSTANTS.SHOW
  );

  return responseData;
}

export async function childInvoiceAdjust(
  invoiceUuid: string,
  body: {
    amount: string;
    officeUuid: string;
    type: number;
  }
) {
  const url = replacePlaceholders(API_URL.INVOICE.CHILD_INVOICE_ADJUST, {
    invoiceUuid,
    officeUuid: body.officeUuid,
  });
  const res = await apiCall.patch(url, body);
  const responseData = await handleResponse(
    res,
    CONSTANTS.NOT_VALUE,
    CONSTANTS.COMMON_CONSTANTS.SHOW,
    CONSTANTS.COMMON_CONSTANTS.SHOW
  );

  return responseData;
}
